<template>
  <div class="giftcard-reassurance">

    <!-- Feature cards grid -->
    <div class="reassurance-grid mb-4">

      <div class="reassurance-card">
        <div class="reassurance-icon-circle">
          <i class="fa-regular fa-clock" aria-hidden="true"></i>
        </div>
        <p class="raleway-medi-p15 mb-1">Valable 2 ans</p>
        <p class="raleway-reg-p13 text-secondary-custom mb-0">Utilisable sur l'ensemble des hébergements Hortense, sans date imposée.</p>
      </div>

      <div class="reassurance-card">
        <div class="reassurance-icon-circle">
          <i class="fa-regular fa-envelope" aria-hidden="true"></i>
        </div>
        <p class="raleway-medi-p15 mb-1">Envoi immédiat</p>
        <p class="raleway-reg-p13 text-secondary-custom mb-0">Réception par e-mail dans la minute. Idéale pour les cadeaux de dernière minute.</p>
      </div>

      <div class="reassurance-card">
        <div class="reassurance-icon-circle">
          <i class="fa-regular fa-calendar-check" aria-hidden="true"></i>
        </div>
        <p class="raleway-medi-p15 mb-1">Envoi différé possible</p>
        <p class="raleway-reg-p13 text-secondary-custom mb-0">Programmez l'envoi au jour J : anniversaire, Noël, fête des mères…</p>
      </div>

      <div class="reassurance-card">
        <div class="reassurance-icon-circle">
          <i class="fa-solid fa-lock" aria-hidden="true"></i>
        </div>
        <p class="raleway-medi-p15 mb-1">Paiement sécurisé</p>
        <p class="raleway-reg-p13 text-secondary-custom mb-0">Transaction chiffrée SSL. Visa et Mastercard acceptés.</p>
      </div>

    </div>

    <!-- Eco banner -->
    <!-- <div class="eco-banner mb-4">
      <i class="fa-solid fa-leaf eco-leaf-icon" aria-hidden="true"></i>
      <div>
        <p class="raleway-medi-p15 mb-1">+350 hébergements de charme éco-responsables sélectionnés</p>
        <p class="raleway-reg-p13 text-secondary-custom mb-0">Chaque établissement est soigneusement sélectionné sur ses engagements environnementaux : labellisation, circuits courts, gestion des ressources.</p>
      </div>
    </div> -->

    <!-- Testimonials -->
    <div class="testimonials-grid">

      <div class="testimonial-card">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center" style="gap: 8px;">
            <div class="avatar-circle">SM</div>
            <p class="raleway-medi-p15 mb-0">Sophie M.</p>
          </div>
          <div class="stars-row">
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
          </div>
        </div>
        <p class="raleway-reg-p13 text-secondary-custom mb-0 fst-italic">"Offert à ma mère pour ses 60 ans. Elle a trouvé la maison d'hôtes idéale en Dordogne — un séjour dont elle parle encore."</p>
      </div>

      <div class="testimonial-card">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center" style="gap: 8px;">
            <div class="avatar-circle">TL</div>
            <p class="raleway-medi-p15 mb-0">Thomas L.</p>
          </div>
          <div class="stars-row">
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
          </div>
        </div>
        <p class="raleway-reg-p13 text-secondary-custom mb-0 fst-italic">"La carte cadeau programmée pour Noël était parfaite. Simple à utiliser, le choix d'hébergements est vraiment qualitatif."</p>
      </div>

      <div class="testimonial-card">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center" style="gap: 8px;">
            <div class="avatar-circle">CR</div>
            <p class="raleway-medi-p15 mb-0">Claire R.</p>
          </div>
          <div class="stars-row">
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
            <i class="fa-solid fa-star" aria-hidden="true"></i>
          </div>
        </div>
        <p class="raleway-reg-p13 text-secondary-custom mb-0 fst-italic">"Un cadeau à la fois beau et engagé. On a utilisé la carte pour un lodge dans les Cévennes — dépaysement total, impact minimal."</p>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'giftcard-reassurance'
};
</script>

<style scoped lang="scss">
.giftcard-reassurance {
  width: 100%;
  padding: 1.5rem 0 1rem;

  .reassurance-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 12px;
  }

  .reassurance-card {
    background: #ffffff;
    border: 0.5px solid rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .reassurance-icon-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #e8f5ee;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 16px;
      color: #3B6152;
    }
  }

  .eco-banner {
    border: 0.5px solid rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    padding: 1rem 1.25rem;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .eco-leaf-icon {
    font-size: 20px;
    color: #3B6152;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .testimonials-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 10px;
  }

  .testimonial-card {
    background: #f4faf6;
    border-radius: 10px;
    padding: 1rem 1.25rem;
  }

  .avatar-circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #c8e6d4;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: $Raleway;
    font-size: 11px;
    font-weight: 500;
    color: #3B6152;
    flex-shrink: 0;
  }

  .stars-row {
    display: flex;
    gap: 2px;

    i {
      font-size: 11px;
      color: #3B6152;
    }
  }

  .text-secondary-custom {
    color: black;
    line-height: 1.5;
  }

  .fst-italic {
    font-style: italic;
  }

  @media screen and (max-width: 768px) {
    .reassurance-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .testimonials-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>
